import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <main className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>We're here to help you start your healthcare career journey</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form">
              <h2>Send Us a Message</h2>
              <form>
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input type="text" id="name" required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input type="email" id="email" required />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" />
                </div>
                <div className="form-group">
                  <label htmlFor="program">Program of Interest</label>
                  <select id="program" required>
                    <option value="">Select a program</option>
                    <option>Home Care Aide</option>
                    <option>CNA Bridge Program</option>
                    <option>Nurse Delegation</option>
                    <option>HIV/AIDS Training</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Your Message</label>
                  <textarea id="message" rows="5" required></textarea>
                </div>
                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="contact-info">
              <h2>Get In Touch</h2>
              <div className="info-item">
                <div className="info-icon">📍</div>
                <div className="info-text">
                  <h3>Location</h3>
                  <p>1305 S. 312th St Suite 202<br />Federal Way, WA 98003</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">📞</div>
                <div className="info-text">
                  <h3>Phone</h3>
                  <p>+1 206 566 4676<br />+1 206 592 2115</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">✉️</div>
                <div className="info-text">
                  <h3>Email</h3>
                  <p>homeaidecnacenter@gmail.com</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">⏰</div>
                <div className="info-text">
                  <h3>Hours</h3>
                  <p>Monday-Friday: 9:00 AM - 5:00 PM<br />
                  Saturday: 9:00 AM - :00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <h2>Find Us</h2>
            <div className="map-container">
              <iframe 
                title="Location Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2701.234567890123!2d-122.31234567890123!3d47.31234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905c2345678901%3A0x1234567890abcdef!2sHome%20Aide%20CNA%20Bridge%20Training%20Center!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus" 
                width="100%" 
                height="450" 
                style={{border:0}}
                allowFullScreen="" 
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;